import React from "react";
import "./Loader.css"; // Import the CSS

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="spinner" />
      <p>Loading...</p>
    </div>
  );
};

export default Loader;
